import HandWritingController from './hand-writing';
import getPosition from '../utils/get-position'

/**
 * テキスト入力に基本的なコントローラ。
 * HandWritingControllerから派生する。
 * 
 * [依存関係]
 * HandWritingController
 * 
 * @param {*} $scope 
 */
export default function($scope) {
  HandWritingController($scope);

  /**
   * 描画位置データ保持
   */
  $scope.drawing = Object.assign({
    start: {x:0, y:0},
    strokeMin: {x:-1, y:-1},
    strokeMax: {x:-1, y:-1}
  }, $scope.drawing);

  /**
   * 描画位置データをリセット
   * @param {Event} e 
   */
  $scope.resetDrawing = function(e) {
    $scope.drawing.flag = false;
    $scope.drawing.strokeMax.x = -1;
    $scope.drawing.strokeMax.y = -1;
    $scope.drawing.strokeMin.x = -1;
    $scope.drawing.strokeMin.y = -1;
  }

  /**
   * onMouseDown: 描画位置の記録
   */
  $scope.superOnMouseDown = $scope.onMouseDown;
  $scope.onMouseDown = function(e) {
    $scope.superOnMouseDown(e);

    // 描画ストロークデータ初期化
    // １文字で何度もMouseDownが発生するので、export された直後のみ。
    if ($scope.drawing.strokeMin.x == -1) {
      const p = getPosition(e);
      $scope.drawing.strokeMin.x = p.x;
      $scope.drawing.strokeMin.y = p.y;
      $scope.drawing.strokeMax.x = p.x;
      $scope.drawing.strokeMax.y = p.y;
    }
  }

  /**
   * onMouseMove: x,yのMaxを更新する
   * @param {*} e 
   */
  $scope.onMouseMove = function(e) {
    if ($scope.drawing.flag) {
      const p = getPosition(e);
      $scope.drawing.strokeMax.x = Math.max($scope.drawing.strokeMax.x, p.x)
      $scope.drawing.strokeMax.y = Math.max($scope.drawing.strokeMax.y, p.y)
      $scope.drawing.strokeMin.x = Math.min($scope.drawing.strokeMin.x, p.x)
      $scope.drawing.strokeMin.y = Math.min($scope.drawing.strokeMin.y, p.y)
    }
    e.preventDefault();
    e.stopPropagation();
  }

  $scope.superOnExported = $scope.onExported;
  /**
   * 認識結果受信後の処理: 既存処理に合わせて selectDrawingAnswer() を呼ぶ
   * @param {*} e 
   */
  $scope.onExported = function(e) {
    const editor = e.target.editor;

    if (editor && e.detail.exports) {
      const match = e.target.id.match(/\d+_\d+_\d+/);
      const id = match ? match[0] : "";
      // const char = e.detail.exports['text/plain'];//ver 1.5.4 にて使えない

      const jiix = typeof e.detail.exports["application/vnd.myscript.jiix"] == 'string'
      ? JSON.parse(e.detail.exports["application/vnd.myscript.jiix"])
      : e.detail.exports["application/vnd.myscript.jiix"];//RESTはObject

      const char = jiix.label;

      if (id && char && jiix) {
        // 手書き描画を消去する
        $scope.link.clearCanvas();

        // 後処理
        e.printId = id;
        e.exportedChar = char;
        e.exportedJiix = jiix;
        $scope.setWritingRange(e);
        $scope.afterExported(e);
        // ストロークデータ消去
        $scope.resetDrawing(e);
      }
    }

    $scope.superOnExported(e);
  }

  /**
   * 受信結果解析後に既存の筆跡範囲の変数をセットする
   * @param {object} param event オブジェクトに以下の情報を加えたデータ
   * @param {string} param.printId DOMのIDから抽出したプリントID。既存処理に必要。
   * @param {string} param.exportedChar exports[text/plain] の文字
   * @param {object} param.exportedJiix 認識結果
   * 
   */
  $scope.setWritingRange = function(param) {
    // 入力Box４等分
    const areaInfo = $scope.getWritingAreaInfo(param.target);

    // プリントのグローバル変数を初期化
    drawingTextSide = '';

    // 筆跡範囲: LEFT
    if ($scope.drawing.strokeMax.x <= areaInfo.largeW) {
      if ($scope.drawing.strokeMax.y <= areaInfo.largeH) {
        // console.log('筆跡 左上')
        drawingTextSide = CANVAS_CORNER.LEFT_TOP;
      }
      else if ($scope.drawing.strokeMin.y >= areaInfo.smallH) {
        // console.log('筆跡: 左下')
        drawingTextSide = CANVAS_CORNER.LEFT_BOTTOM;
      }
    }
    // 筆跡範囲: RIGHT
    else if ($scope.drawing.strokeMin.x >= areaInfo.smallW) {
      if ($scope.drawing.strokeMax.y <= areaInfo.largeH) {
        // console.log('筆跡: 右上')
        drawingTextSide = CANVAS_CORNER.RIGHT_TOP;
      }
      else if ($scope.drawing.strokeMin.y >= areaInfo.smallH) {
        // console.log('筆跡: 右下')
        drawingTextSide = CANVAS_CORNER.RIGHT_BOTTOM;
      }
    }
    // 筆跡範囲: BOTTOM ONLY
    else if ($scope.drawing.strokeMin.y >= areaInfo.smallH) {
      // console.log('筆跡: 下のみ')
      drawingTextSide = CANVAS_CORNER.ONLY_BOTTOM;
    }
  }

  /**
   * 描画エリアを４分割した場合の幅や高さの情報を返却する
   * @param {element} targetElement HTML要素
   * @returns {object} as { largeW, largeH, smallW, smallH }
   */
  $scope.getWritingAreaInfo = function(targetElement) {
    return {
      // 大きめに４分割した場合の幅と高さ
      largeW: targetElement.clientWidth * 0.55,
      largeH: targetElement.clientHeight * 0.55,
      // 小さめに４分割した場合の幅と高さ
      smallW: targetElement.clientWidth * 0.45,
      smallH: targetElement.clientHeight * 0.45,
    }
  }

  /**
   * 受信結果解析後の処理
   * @param {object} param event オブジェクトに以下の情報を加えたデータ
   * @param {string} param.printId DOMのIDから抽出したプリントID。既存処理に必要。
   * @param {string} param.exportedChar exports[text/plain] の文字
   * @param {object} param.exportedJiix 認識結果
   */
  $scope.afterExported = function(param) {
    //Todo subclass
  }

  /**
   * API発行直前の処理
   */
  $scope.beforeExportApi = () => {
    // API 発行を登録（既存処理連携）
    let m = ($scope.element.attr('id') || "").match(/\d+\_\d+\_\d+$/);// == textInput0_0_1
    const componentId = m ? m[0] : currentComponentId;
    setDoingRecognition(componentId, 5000)
  }
}